import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    OrderCardRoot: {
        borderRadius: 8,
    },
    HighlightCard: {
        animation: "$flash 1200ms ease-in-out 0ms 3",
    },
    "@keyframes flash": {
        "0%": { boxShadow: "0 0 0 rgba(225,73,84,0)" },
        "50%": { boxShadow: "0 0 0 6px rgba(225,73,84,0.25)" },
        "100%": { boxShadow: "0 0 0 rgba(225,73,84,0)" },
    },
    ItemAdded: {
        animation: "$itemFlash 1200ms ease-in-out 0ms 2",
    },
    "@keyframes itemFlash": {
        "0%": { backgroundColor: "transparent" },
        "50%": { backgroundColor: "#fff1f2" },
        "100%": { backgroundColor: "transparent" },
    },
    OrderCardHeader: {
        display: "flex",
        alignItems: "center",
        marginBottom: 8,
        "& .left": {
            marginRight: "auto",
        },
        "& .right": {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
        },
        "& .title": {
            fontWeight: 700,
        },
        "& .subtitle": {
            color: "#6E7187",
        },
    },
    OrderNotes: {
        background: "#fff7f7",
        border: "1px solid #fde0e0",
        color: "#8a1f1f",
        borderRadius: 6,
        padding: "8px 10px",
        marginBottom: 8,
        whiteSpace: "pre-wrap",
    },
    OrderMeta: {
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        color: "#6E7187",
        marginBottom: 8,
        "& .created": {
            fontWeight: 700,
            color: "#271D1C",
        },
    },
    CardDivider: {
        marginBottom: 12,
    },
    GroupHeader: {
        color: "#6E7187",
    },
    GroupHeaderRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    GroupItems: {
        marginTop: 4,
        marginBottom: 8,
    },
    AddonsHeader: {
        color: "#6E7187",
        marginLeft: 8,
    },
    AddonsRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: 6,
        marginTop: 6,
    },
    AddonItem: {
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 10,
        paddingRight: 10,
        '&.ItemAdded': {
            animation: "$itemFlash 1200ms ease-in-out 0ms 2",
        }
    },
    StatusHeader: {
        fontWeight: 700,
        color: "#271D1C",
        marginBottom: 6,
    },
    ItemButton: {
        justifyContent: "space-between",
        textTransform: "none",
        fontSize: "1.05rem",
        paddingTop: 12,
        paddingBottom: 12,
    },
    ItemButtonInner: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        flexWrap: "wrap",
        "& .name": {
            fontWeight: 600,
        },
        "& .notes": {
            display: "block",
            color: "#6E7187",
        },
        "& .meta": {
            color: "#6E7187",
        },
        "& .qtyPill": {
            background: "#e14954",
            color: "#fff",
            borderRadius: 12,
            padding: "2px 8px",
            fontWeight: 700,
            marginLeft: 8,
            fontSize: 12,
        },
        "& .statusChange": {
            color: "#6E7187",
            fontStyle: "italic",
            width: "100%",
            marginTop: 4,
        },
    },
}));

